import React from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useRef , useEffect} from 'react';
import {isMobileOnly, isIOS} from 'react-device-detect';
import { remove, uniq, filter, forEach, findIndex, split } from 'lodash';
import Slider from "react-slick";
import { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import { getcategoryFilterInfoAction, getEsCountPDFilterInfoAction, getCategoryCountFromPriceInfoAction } from '../../modules/common/prodModule';
import { useHistory } from 'react-router-dom';

const CateFilterPopupBlock = styled.div`
    position: fixed;
    //background-color: rgba(17, 17, 17, 0.3);
    z-index: 100;
    
    ${isMobileOnly?`
    width: 100vw; 
    `:`
    width: 100%;
    height: 100%;
    `};

    ${isMobileOnly?`
    bottom: 0;
    transform: translateY(100vh);
    transition: transform 0.3s ease,opacity 0.3s ease;
    `:`
    top: 0;
    //left: -100%;
    transform: translateX(-100%);
    transition: transform 0.3s ease,opacity 0.3s ease;
    width: 100%;
    `};

    .close-pop {
        ${isMobileOnly?`
        height: calc(100vh - 510px);
        width: 100wh;  
        `:`
        //height: 100vh;
        width: calc(100% - 435px);
        `};
    }

    &.active {
        ${isMobileOnly?`
        transform: translateY(0px);
        height: 100vh; 
        `:`
        transform: translateX(0);
        width: 100%;
        display:block;
        `};
    }

    &.active-no {
        ${isMobileOnly?`
        transform: translateY(100vh);
        //height: 0vh;
        height: 100vh;
        `:`
        transform: translateX(-100%);
        //height: 0vh;
        width: 100%;
        display:none;
        `};
    }

    &.hide {
        display:none;
    }

    .cate {
        
    }

`;

const CateFilterBrandCatePCPopupContainerBlock = styled.div`
    .left_con {
        height: 100vh;
        background-color: #ffffff;
        float: left;
        width: 435px;
        //overflow: scroll;

        .top_block {
            height: 183px;
            width: 100%;
            background-color: #ffffff;
            

            .close_btn {
                margin-top: 40px;
                margin-left: 375px;
                width: 36px;
                height: 36px;
                background: url(/assets/images/icon/pp_btn_delete.png) center center/auto no-repeat;
                //position: fixed;
                background-size: 14px 14px;
            }

            .header_block {
                padding-left: 40px;
            }
        }
    }

    .right_con {
        float: left;
        height: 100vh;
        width: calc(100% - 435px);
        .continue {
            font-size: 52px;
            font-weight: normal;
            line-height: 100vh;
            color: #ffffff;
            margin-left: 60px;
            font-family: 'Dancing Script',cursive;
        }
    }
`;

const CateFilterPopupContainerBlock = styled.div`
    ${isMobileOnly?`
    height: 510px;
    `:`
    //height: 650px;
    `};
    color: #111111;
    position: relative;
    
    .top-blank {
        height: 10px;
        width: 100vw;
    }

    .top-bar {
        border-radius: 4px;
        background-color: #ffffff;
        width: 50px;
        height: 8px;
        margin: 0 auto;
        margin-bottom: 10px;
    }

    .container {
        ${isMobileOnly?`
        background-color: #ffffff;
        border-top-right-radius: 12px;
        border-top-left-radius: 12px;
        padding: 26px 4vw 0;
        height: 490px;
        `:`
        padding: 0px 40px 0px;
        height: calc(100vh - 340px);;
        overflow: auto;
        width: 100%;
        `};
    }

    .slider_es {
        width: 100%;
        
        ${isMobileOnly?`
        height: 320px;
        `:`
        //height: 511px;
        `};
        position:relative;
    }

    .container_brand {
        ${isMobileOnly?`
        height: 320px;
        overflow-y: scroll;
        `:`
        //height: 511px;
        overflow-y: auto;
        `};
        position: relative;
        
    }

    .container_price {
        ${isMobileOnly?`
        height: 320px;
        overflow-y: scroll;
        `:`
        //height: 511px;
        overflow-y: auto;
        overflow-x: hidden;
        `};
        position: relative;
        color: #333333;
        font-size: 22px;
        font-weight: bold;
        line-height: 1.33;
        
        .price {
            padding-top: 15px;
        }
        .num {
            font-size: 24px;
            font-weight: 600;
        }

        .range {
            padding: 35px 18px;
        }

        .rc-slider-handle  {
            background: url(/assets/images/icon/slider_handle.png) center center/auto no-repeat;
            background-size: 36px;
            margin-top: -12px;
        }

        .rc-slider-handle-dragging {
            border-color: none;
            box-shadow: none;
        }
    }

    .container_option {
        ${isMobileOnly?`
        height: 320px;
        overflow-y: scroll;
        `:`
        //height: 511px;
        overflow-y: auto;
        `};
        position: relative;
        
        .title {
            ${isMobileOnly?`
            height: 18px;
            font-size: 12px;
            line-height: 1.5;
            `:`
            height: 20px;
            font-size: 14px;
            line-height: 1.43;
            `};
            
            color: #333333;
            margin-bottom: 10px;
        }

        .tag {
            ${isMobileOnly?`
            margin-bottom: 20px;
            `:`
            margin-bottom: 30px;
            `};
        }
    }

    *:focus {
        outline: 0;
        outline: none;
      }
`;

const CateFilterPopupTitleBlock = styled.div`
    ${isMobileOnly?`
    font-size: 16px;
    text-align: center;
    margin-bottom: 20px; 
    `:`
    font-size: 18px;
    margin-bottom: 40px; 
    `};
    
    font-weight: bold;
    line-height: 1.5;
    cursor: pointer;
    height: 24px;
    margin-right: 20px;
    float: left;
    position: relative;

    color:${props => props.active? '#111111' : '#cccccc'};

    ::after {
        content: '';
        display: ${props => props.change? 'inline-block' : 'none'};
        width: 4px;
        height: 4px;
        position: absolute;
        top: -7px;
        margin-top: 5px;
        background-color: #fd683a;
        border-radius: 50%;
    }
`;

const CateFilterPopupOptionBlock = styled.div`
    background-color:${props => props.active? '#ffe7ad' : '#f4f4f4'};
    padding: 3px 11px 3px 12px;
    border-radius: 12px;
    height: 24px;
    font-weight: normal;
    line-height: 18px;
    
    float: left;
    margin-right: 6px;
    margin-bottom: 10px;
    ${isMobileOnly?`
    font-size: 12px;
    `:`
    font-size: 14px;
    `};
    cursor: pointer;

    color:${props => props.active? '#333333' : '#999999'};

    .num {
        font-weight: 500;
    }
`;

const BottomBlock = styled.div`
    ${isMobileOnly?`
    position:fixed;
    width: 100vw;
    padding: 20px 4vw;
    `:`
    position:absolute;
    width: 435px;
    padding: 20px 40px 40px;
    `};
    
    bottom:0;
    z-index: 101;
    font-size: 13px;
    line-height: 1.46;
    font-weight: normal;
    //border-top: solid 1px #cccccc;
    display: block;
    background-color: #ffffff;
    //height: 145px;

    .line {
        background-color: #cccccc;
        height: 1px;
        ${isMobileOnly?`
        margin-left: -4vw;
        width: 100vw;
        `:`
        width: 100%;
        `};
    }

    .bottom-container {
        position: relative;
    }
    .list {
        padding: 0 18px 0 16px;
    }
    
    .pre {
        border-radius: 4px;
        background-color: #ececec;
        background: url(/assets/images/icon/refresh.png) center center/auto no-repeat, #ececec;
        text-align: center;
        color: #333333;
        height: 52px;
        width: 18%;
        float: left;
        background-size: 17px 17px;
    }

    .apply {
        border-radius: 4px;
        background-color: #111111;
        text-align: center;
        color: #ffffff;
        height: 52px;
        width: 79%;
        float: right;
        .num {
            font-weight: bold;
        }
    }
`;

const CateFilterPopup = ({info, active, handleClosePopup, pCate1Id, pCate2Id, pIndex, handleReceiveFromPopup, brandId, _maxPrice, _curPrice, search}) => {
    const history = useHistory();
    const refbox = useRef(null);
    const refContainer = useRef(null);
    const dispatch = useDispatch();
    const [allBrand , setAllBrand]=useState(true);
    const [curPrice, setCurPrice] = useState([0, 0]);
    const [minPirce, setMinPrice] = useState(0);
    const [maxPirce, setMaxPrice] = useState(0);
    const [cateId, setCateId] = useState(-1);
    const [arrCateId, setArrCateId] = useState([]);
    const [arrFilter, setArrFilter] = useState([]);
    const refSlider = useRef(null);
    const [curIndex, setCurIndex] = useState(0);
    const [startY, setStartY] = useState(0);
    const [moveY, setMoveY] = useState(0);
    const [scrollPosition, setScrollPosition] = useState(0);
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: isMobileOnly?1:1,  // 1 slide if mobile
        slidesToScroll: 1,
        variableWidth: false,
        arrows: false,
        draggable: isMobileOnly?true:false,
        //swipeToSlide: true,
        afterChange: (current) => setCurIndex(current),
      };

    const { esCountProdFromFilter, categoryFilterInfo, countFromPriceCategory} = useSelector(
        ({  prodItemsReducer }) => ({
            esCountProdFromFilter: prodItemsReducer.esCountProdFromFilter,
            categoryFilterInfo: prodItemsReducer.categoryFilterInfo,
            countFromPriceCategory: prodItemsReducer.countFromPriceCategory,
        })
    );

    useEffect(() => {
        const handleEnd = (e) => {
            if(isMobileOnly) {
                if(refbox.current.getBoundingClientRect().top > 100) {
                    refbox.current.classList.add('hide');
                } else {
                    refbox.current.classList.remove('hide');
                }
            }
        }
        document.addEventListener("transitionend", handleEnd);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("transitionend", handleEnd);
        };
    }, []);

    useEffect(() => {
        if(refbox && refbox.current) {
            if(active) {
                refbox.current.classList.remove('hide');
                refbox.current.classList.remove('active-no');
                setTimeout(() => {
                    refbox.current.classList.add('active');
                }, 10);
                
                if(isMobileOnly) {
                    if(isIOS) {
                        const _scrollPosition = window.pageYOffset;
                        setScrollPosition(_scrollPosition);
                        
                        document.body.style.top = `-${_scrollPosition}px`;
                        document.body.style.position= 'fixed';
                        
                    } else {
                        document.body.style.overflow = 'hidden';
                    }
                } else {
                    document.body.style.overflow = 'hidden';
                }
            } else {
                refbox.current.classList.remove('active');
                refbox.current.classList.add('active-no');

                if(isMobileOnly) {
                    //document.body.style.overflow = 'unset';
                    //document.body.style.position= 'relative';
                    document.body.removeAttribute('style');
                    if(isIOS) {
                        window.scrollTo(0,scrollPosition);
                    }
                } else {
                    //document.body.style.overflow = 'auto';
                    document.body.removeAttribute('style');
                }
            }
        }
    }, [active]);


    useEffect(() => {
        if(pCate1Id !== null && pCate1Id !== undefined) {
            let cateId = pCate1Id*100 + pCate2Id;
            setCateId(cateId);
            
            if(pCate2Id*1>0) {
                dispatch(getEsCountPDFilterInfoAction(cateId, [], [], 0, 0, brandId, search));
            }
            setArrCateId([]);
            setArrFilter([]);
        }
    }, [pCate1Id, pCate2Id]);

    useEffect(() => {
        
        if(pIndex !== null && pIndex !== undefined && pIndex*1 >= 0) {
            if(refSlider && refSlider.current) {
                refSlider.current.slickGoTo(pIndex);
            }
            setCurIndex(pIndex);
        }
    }, [pIndex]);

    useEffect(() => {
        if(_maxPrice !== null && _maxPrice !== undefined && _maxPrice.length > 1) {
            setMinPrice(_maxPrice[0]*1);
            setMaxPrice(_maxPrice[1]*1);
        }
    }, [_maxPrice]); 

    useEffect(() => {
        if(_curPrice !== null && _curPrice !== undefined && _curPrice.length > 1) {
            setCurPrice([_curPrice[0]*1, _curPrice[1]*1]);
        }
    }, [_curPrice]);

    useEffect(() => {
        //if( maxPirce > 0&&((arrCateId&&arrCateId.length>0) || (arrFilter&&arrFilter.length>0))) {
            if(curPrice&&curPrice.length>0&&curPrice[1] > 0) {
            let cateid = [];
            forEach(arrCateId, (curobj, index) => {
                cateid.push(curobj.id);
            });
            //console.log("cateid = " + cateId)
            //console.log("curPrice[0] = " + curPrice[0])
            //console.log("curPrice[1] = " + curPrice[1])
            dispatch(getEsCountPDFilterInfoAction(cateId, arrFilter, cateid, curPrice[0], curPrice[1], brandId, search));
            
        }
    }, [arrCateId, arrFilter, curPrice]);

    const onClick = (e) => {
        e.stopPropagation();
        if(handleClosePopup !== null && handleClosePopup !== undefined) {
            handleClosePopup();
        }
        
    }

    const onClickContainer = (e) => {
        
    }

    const handleRefresh = (e) => {
        //setArrCate3Step(esMyBrandCate1Step);
        if(curIndex === 0) { // 가격
            setCurPrice([minPirce*1,maxPirce*1]);
            
            let cateid = [];
            forEach(arrCateId, (curobj, index) => {
                cateid.push(curobj.id);
            });
            dispatch(getEsCountPDFilterInfoAction(cateId, arrFilter, cateid, minPirce, maxPirce, brandId, search));
        } else { //옵션
            let check = [];
            setArrFilter(check);
            setArrCateId(check);
        }
    }

    const handleApply = (e) => {
        let _arrCate3Id = [];
        forEach(arrCateId, (curobj, index) => {
            if(esCountProdFromFilter&&esCountProdFromFilter.cateItem&&esCountProdFromFilter.cateItem.cate_count&&esCountProdFromFilter.cateItem.cate_count.buckets!==undefined) {
                forEach(esCountProdFromFilter.cateItem.cate_count.buckets, (cateitem, index) => {
                    if(cateitem.key*1 === curobj.id*1) {
                        _arrCate3Id.push(curobj);
                    }
                });
            }
        });
        let _arrFilter = [];
        forEach(arrFilter, (curobj, index) => {
            esCountProdFromFilter&&esCountProdFromFilter.filterItem&&esCountProdFromFilter.filterItem.filter_count&&esCountProdFromFilter.filterItem.filter_count!==undefined&&esCountProdFromFilter.filterItem.filter_count.count.buckets.map((item,index) => {
                item.filter_key.buckets.map((filter,index) => {
                    if(filter.key === curobj) {
                        _arrFilter.push(curobj);
                    }
                })
            })
        });

        if(handleReceiveFromPopup !== null && handleReceiveFromPopup !== undefined) {
            if(curPrice[0]*1 === minPirce*1 && curPrice[1]*1 === maxPirce*1){
                handleReceiveFromPopup([0,0], _arrCate3Id, _arrFilter);
            } else {
                handleReceiveFromPopup(curPrice, _arrCate3Id, _arrFilter);
            }
            
            handleClosePopup();
        }
    }

    const getChange = (index) => {
        if(index === 0) { //가격
            if(minPirce !== curPrice[0] || maxPirce !== curPrice[1]) {
                return true;
            }
            return false;
        } else { //옵션
            if(arrCateId.length > 0 || arrFilter.length > 0) {
                return true;
            }
            return false;
        }
    }
    const handleMenu = (index) => {
        if(refSlider && refSlider.current) {
            refSlider.current.slickGoTo(index);
        }
        setCurIndex(index);
    }

    const handleCate = (cateid, name) => {
        let idx = findIndex(arrCateId, (curitem) => {
            //console.log("curitem = " + curitem + " cate.id = "+ cate.id);
            return curitem.id*1 === cateid*1;
        })

        let check = [];
        Object.assign(check,arrCateId);

        if(idx >= 0) {
            remove(check, (curitem) => {
                return curitem.id*1 === cateid*1;
            });
            
        } else {
            let cate = {id:cateid, name:name}
            check.push(cate);
        }

        setArrCateId(check);
    }

    const getCateActive = (cateid) => {
        let idx = findIndex(arrCateId, (curitem) => {
            return curitem.id*1 === cateid*1;
        })

        if(idx >= 0) {
            return true;
        } else {
            return false;
        }
    }

    const handleFilter = (filter) => {
        let idx = findIndex(arrFilter, (curitem) => {
            return curitem === filter;
        })

        let check = [];
        Object.assign(check,arrFilter);

        if(idx >= 0) {
            remove(check, (curitem) => {
                return curitem === filter;
            });
            
        } else {
            check.push(filter);
        }

        setArrFilter(check);
    }

    const getFilterActive = (filter) => {
        let idx = findIndex(arrFilter, (curitem) => {
            return curitem === filter;
        })

        if(idx >= 0) {
            return true;
            
        } else {
            return false;
        }
    }

    const handlePriceChange = (value) => {
        setCurPrice([value[0]*1, value[1]*1]);
    }

    const handlePriceAfterChange = (value) => {
        let arrPrice = value.splice(',');
        setCurPrice([arrPrice[0]*1, arrPrice[1]*1]);

        let cateid = [];
        forEach(arrCateId, (curobj, index) => {
            cateid.push(curobj.id);
        });

        if(pCate2Id*1>0) {
            dispatch(getEsCountPDFilterInfoAction(cateId, arrFilter, cateid, arrPrice[0], arrPrice[1], brandId, search));
        } else {
            dispatch(getCategoryCountFromPriceInfoAction(pCate1Id,pCate2Id,brandId, arrPrice[0],arrPrice[1], search));
        }
    }

    const  touchX = (event) => {
        if ("touches" in event && event.touches.length >= 1) {
            const { clientX, clientY } =
            "touches" in event ? event.touches[0] : event;

            return clientX;
          }
        
          return;
    }

    const touchY = (event) => {
        //return;
        if ("touches" in event && event.touches.length >= 1) {
            const { clientX, clientY } =
            "touches" in event ? event.touches[0] : event;

            return clientY;
        }
        return;
    }

    const touchCancel = (e) => {
        
    }

    const touchEnd = (e) => {
        if(isMobileOnly && startY > 0) {
            //if(moveY - startY > 70) {
                if(handleClosePopup !== null && handleClosePopup !== undefined) {
                    handleClosePopup();
                }
            //}
        }

        setMoveY(0);
        setStartY(0);
    }

    const touchMove = (e) => {
        if(isMobileOnly && startY > 0) {
            let moveY = touchY(e);
            setMoveY(moveY);
        }
    }

    const touchStart = (e) => {

        if(isMobileOnly && refContainer && refContainer.current){
            let startY = touchY(e);
            //console.log('topY = ' + refContainer.current.getBoundingClientRect().top)

            if(startY - refContainer.current.getBoundingClientRect().top < 40) {
                setStartY(startY);
            }
        }
    }

    const getCount = ()=> {
        
        if(pCate2Id*1>0) {
            if(esCountProdFromFilter&&esCountProdFromFilter.total_num&&esCountProdFromFilter.total_num.doc_count) {
                //console.log('esCountProdFromFilter.total_num.doc_count = ' + esCountProdFromFilter.total_num.doc_count)
                return esCountProdFromFilter.total_num.doc_count;
            } else {
                return 0;
            }
        } else {
            if(minPirce*1 === curPrice[0]*1 && maxPirce*1 === curPrice[1]*1) {
                if(categoryFilterInfo&&categoryFilterInfo.hits&&categoryFilterInfo.hits.total&&categoryFilterInfo.hits.total.value) {
                    //console.log('categoryFilterInfo.hits.total.value = ' + categoryFilterInfo.hits.total.value)
                    return categoryFilterInfo.hits.total.value;
                }
            } else {
                if(countFromPriceCategory&&countFromPriceCategory.value) {
                    //console.log('countFromPriceCategory.value = ' + countFromPriceCategory.value)
                    return countFromPriceCategory.value;
                } else {
                    if(categoryFilterInfo&&categoryFilterInfo.hits&&categoryFilterInfo.hits.total&&categoryFilterInfo.hits.total.value) {
                        //console.log('categoryFilterInfo.hits.total.value = ' + categoryFilterInfo.hits.total.value)
                        return categoryFilterInfo.hits.total.value;
                    }
                }
                
            }
        }
        
        return "";
    }

    const getPriceBlock = () => {
        if(curPrice&&curPrice.length>1)
        return(
            <div className="container_price">
                <div className="price"><span className="num">{Number(curPrice[0].toFixed(1)).toLocaleString()}</span>원 ~ <span className="num">{Number(curPrice[1].toFixed(1)).toLocaleString()}</span>원</div>
                <div className="range">
                {
                    <Range
                        min={minPirce}
                        max={maxPirce}
                        defaultValue={curPrice}
                        value={curPrice}
                        step="10000"
                        railStyle={{ height:'6px',top:'9px' }}
                        trackStyle={[{ backgroundColor: '#ffe7ad',height:'6px',top:'9px' },{ backgroundColor: '#ffe7ad',height:'6px',top:'9px' }]}
                        handleStyle={[{ borderColor: '#ffc742',width:'36px',height:'36px', borderWidth: '0px', backGround:'url(/assets/images/icon/btn_delete.png)' }, { borderColor: '#ffc742' ,width:'36px',height:'36px',borderWidth: '0px', backGround:'url(/assets/images/icon/btn_delete.png)'}]}
                        onChange={handlePriceChange}
                        onAfterChange={handlePriceAfterChange}
                        allowCross={false} />
                }
                </div>
            </div>
        )
    }

    const getOptionBlock = () => {
        if(categoryFilterInfo === null || categoryFilterInfo === undefined) {
            return <div className="container_option" />
        }

        if((arrFilter && arrFilter.length > 0) || (arrCateId && arrCateId.length > 0) || (curPrice[0]*1 !== minPirce*1 || curPrice[1]*1 !== maxPirce*1)) {
            return(
                <div className="container_option">
                    <div className="title">분류</div>
                    <div className="tag clearfix">
                    {
                        esCountProdFromFilter&&esCountProdFromFilter.cateItem&&esCountProdFromFilter.cateItem.cate_count&&esCountProdFromFilter.cateItem.cate_count!==undefined&&esCountProdFromFilter.cateItem.cate_count.buckets.map((cateitem,index) => {
                            let catenames = split(cateitem.cate_key.buckets[0].key, ' > ');
                            return (
                                <CateFilterPopupOptionBlock key={cateitem.key} onClick={()=>handleCate(cateitem.key, catenames[2])} active={getCateActive(cateitem.key)}>
                                    {catenames[2]}({cateitem.cate_key.buckets[0].doc_count})
                                </CateFilterPopupOptionBlock>
                            );
                            
                        })
                    }
                    </div>
                    {
                        esCountProdFromFilter&&esCountProdFromFilter.filterItem&&esCountProdFromFilter.filterItem.filter_count&&esCountProdFromFilter.filterItem.filter_count!==undefined&&esCountProdFromFilter.filterItem.filter_count.count.buckets.map((item,index) => {
                            return(
                                <div key={item.key}>
                                    <div className="title">{item.key.replace(/[0-9]/g, "")}</div>
                                    <div className="tag clearfix">
                                        {
                                            item.filter_key.buckets.map((filter,index) => {
                                                return (
                                                    <CateFilterPopupOptionBlock key={filter.key} onClick={()=>handleFilter(filter.key)} active={getFilterActive(filter.key)}>
                                                        {filter.key}({filter.doc_count})
                                                    </CateFilterPopupOptionBlock>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            )
        }
        return(
            <div className="container_option">
                <div className="title">분류</div>
                <div className="tag clearfix">
                {
                    categoryFilterInfo&&categoryFilterInfo.aggregations&&categoryFilterInfo.aggregations.cate_count&&categoryFilterInfo.aggregations.cate_count!==undefined&&categoryFilterInfo.aggregations.cate_count.buckets.map((cateitem,index) => {
                        let catenames = split(cateitem.cate_key.buckets[0].key, ' > ');
                        return (
                            <CateFilterPopupOptionBlock key={cateitem.key} onClick={()=>handleCate(cateitem.key, catenames[2])} active={getCateActive(cateitem.key)}>
                                {catenames[2]}({cateitem.cate_key.buckets[0].doc_count})
                            </CateFilterPopupOptionBlock>
                        );
                        
                    })
                }
                </div>
                {
                    categoryFilterInfo&&categoryFilterInfo.aggregations&&categoryFilterInfo.aggregations.filter_count&&categoryFilterInfo.aggregations.filter_count!==undefined&&categoryFilterInfo.aggregations.filter_count.count.buckets.map((item,index) => {
                        return(
                            <div key={item.key}>
                                <div className="title">{item.key.replace(/[0-9]/g, "")}</div>
                                <div className="tag clearfix">
                                    {
                                        item.filter_key.buckets.map((filter,index) => {
                                            return (
                                                <CateFilterPopupOptionBlock key={filter.key} onClick={()=>handleFilter(filter.key)} active={getFilterActive(filter.key)}>
                                                    {filter.key}({filter.doc_count})
                                                </CateFilterPopupOptionBlock>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
    return (
        isMobileOnly?
        <CateFilterPopupBlock  ref={refbox}>
            <div className="close-pop" /* onMouseDown = {onClick} onTouchStart={onClick}  */onClick={onClick}>&nbsp;</div>
            <CateFilterPopupContainerBlock ref={refContainer} onTouchStart={touchStart} onTouchMove={touchMove} onTouchEnd={touchEnd} onTouchCancel={touchCancel}>
                <div className="top-blank "/>
                <div className="top-bar" ></div>
                <div className="container" onClick={onClickContainer}>
                    <div className="clearfix">
                        <CateFilterPopupTitleBlock active={curIndex*1 === 0? true:false} change={getChange(0)} onClick={()=>handleMenu(0)}>가격</CateFilterPopupTitleBlock>
                        {
                            pCate2Id&&pCate2Id*1>0?
                            <CateFilterPopupTitleBlock active={curIndex*1 === 1? true:false} change={getChange(1)} onClick={()=>handleMenu(1)}>옵션</CateFilterPopupTitleBlock>
                            :''
                        }
                    </div>
                    <div className="slider_es clearfix">
                        <div className = "si-list slick-initialized slick-slider">
                            {
                                pCate2Id&&pCate2Id*1>0?
                                <Slider  {...settings} ref={refSlider}>
                                    <div>{getPriceBlock()}</div>
                                    <div>{getOptionBlock()}</div>
                                </Slider>
                                :
                                <Slider  {...settings} ref={refSlider}>
                                    <div>{getPriceBlock()}</div>
                                </Slider>
                            }
                            
                        </div>
                    </div>
                </div>
                <BottomBlock>
                    
                    <button className="pre" onClick={handleRefresh}></button><button className="apply" onClick={handleApply}><span className="num">{getCount()}</span>개 상품 보기</button>
                    
                </BottomBlock>
            </CateFilterPopupContainerBlock>

        </CateFilterPopupBlock>
        :
        <CateFilterPopupBlock  ref={refbox}>
        <CateFilterBrandCatePCPopupContainerBlock>
            <div className="left_con">
                <div  className="top_block">
                <button className="close_btn margin_b-40" onClick={onClick}></button>
                <div className="header_block clearfix">
                            <CateFilterPopupTitleBlock active={curIndex*1 === 0? true:false} change={getChange(0)} onClick={()=>handleMenu(0)}>가격</CateFilterPopupTitleBlock>
                            {
                                pCate2Id&&pCate2Id*1>0?
                                <CateFilterPopupTitleBlock active={curIndex*1 === 1? true:false} change={getChange(1)} onClick={()=>handleMenu(1)}>옵션</CateFilterPopupTitleBlock>
                                :''
                            }
                </div>
                </div>
                <CateFilterPopupContainerBlock ref={refContainer} onTouchStart={touchStart} onTouchMove={touchMove} onTouchEnd={touchEnd} onTouchCancel={touchCancel}>
                    
                    <div className="container small_scroll" onClick={onClickContainer}>
                        
                        <div className="slider_es clearfix">
                            <div className = "si-list slick-initialized slick-slider">
                            {
                                pCate2Id&&pCate2Id*1>0?
                                <Slider  {...settings} ref={refSlider}>
                                    <div>{getPriceBlock()}</div>
                                    <div>{getOptionBlock()}</div>
                                </Slider>
                                :
                                <Slider  {...settings} ref={refSlider}>
                                    <div>{getPriceBlock()}</div>
                                </Slider>
                            }
                            </div>
                        </div>
                    </div>
                    
                </CateFilterPopupContainerBlock>
                <BottomBlock>
                        
                    <button className="pre" onClick={handleRefresh}></button><button className="apply" onClick={handleApply}><span className="num">{getCount()}</span>개 상품 보기</button>
                    
                </BottomBlock>
            </div>
            <div className="right_con" onClick={onClick}>
                <div className="continue">continue&gt;</div>
            </div>
        </CateFilterBrandCatePCPopupContainerBlock>
            

        </CateFilterPopupBlock>
    );
};

export default CateFilterPopup;